import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'users/';

export default {
  getAll: () => {
    return api.get(BASE_URL);
  },
  getAllForDropDown: () => {
    return api.get(`${BASE_URL}drop-down-populate`);
  }, 
  getUserMetadata: () => {
    return api.get(`${BASE_URL}metadata`);
  },
  get: (id) => {
    return api.get(`${BASE_URL}${id}`);
  },
  patch: (body) => {
    return api.patch(`${BASE_URL}${body.id}`, body);
  },
  addBankDetails: (userId, bankDetails) => {
    return api.post(`${BASE_URL}${userId}/bank-details`, bankDetails);
  },
  addVatNumber: (userId, vatNumber) => {
    return api.post(`${BASE_URL}${userId}/vat-number`, { vatNumber });
  },
  updateUserCommission: (userId, commission) => {
    return api.put(`${BASE_URL}${userId}/commission`, { commission });
  },
  addAddressDetails: (userId, addressDetails) => {
    return api.post(`${BASE_URL}${userId}/address-details`, addressDetails);
  },
  unsubscribeFromEmails(id, type) {
    return api.get(`${BASE_URL}${id}/unsubscribe`);
  },
  getUserGlobalPostbacks: (userId) => {
    return api.get(`${BASE_URL}${userId}/global-postbacks`);
  },
  updateGlobalPostbacks: (userId, postbacks) => {
    return api.put(`${BASE_URL}${userId}/global-postbacks`, postbacks);
  }
};
